/* ==========================================================
   Vaultborn MTG theme — storefront behaviour
   Cart drawer (Shopify AJAX Cart API), variant picker, couple-card
   live preview, sliders, sticky buy bar, delivery estimates.
   ========================================================== */
(() => {
  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s ?? "").replace(/[&<>"']/g, m => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));

  /* ---------- Money (Shopify money_format) ---------- */
  function money(cents) {
    const fmt = T.moneyFormat || "${{amount}}";
    const n = (cents || 0) / 100;
    const withDelims = (num, dec, thou, decSep) => {
      const [i, d] = num.toFixed(dec).split(".");
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? decSep + d : "");
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: withDelims(n, 2, ",", "."),
      amount_no_decimals: withDelims(n, 0, ",", "."),
      amount_with_comma_separator: withDelims(n, 2, ".", ","),
      amount_no_decimals_with_comma_separator: withDelims(n, 0, ".", ","),
      amount_with_apostrophe_separator: withDelims(n, 2, "'", "."),
    }[k] ?? withDelims(n, 2, ",", ".")));
  }

  /* ---------- Toast ---------- */
  function toast(msg) {
    const t = $(".toast"); if (!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(toast._t); toast._t = setTimeout(() => t.classList.remove("show"), 2400);
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    const menu = $(".menu"); if (!menu) return;
    $$("[data-menu]").forEach(b => b.addEventListener("click", () => {
      const open = menu.classList.toggle("open");
      document.body.style.overflow = open ? "hidden" : "";
    }));
  }

  /* ==========================================================
     CART DRAWER
     ========================================================== */
  const drawer = () => $(".drawer");
  function openDrawer() { drawer()?.classList.add("open"); $(".scrim")?.classList.add("show"); document.body.style.overflow = "hidden"; }
  function closeDrawer() { drawer()?.classList.remove("open"); $(".scrim")?.classList.remove("show"); document.body.style.overflow = ""; }

  async function getCart() { const r = await fetch(T.routes.cartJs, { headers: { Accept: "application/json" } }); return r.json(); }

  let upsells = [];
  try { upsells = JSON.parse($("[data-upsells]")?.textContent || "[]"); } catch { upsells = []; }

  function propsHTML(props) {
    return Object.entries(props || {})
      .filter(([k, v]) => v && !k.startsWith("_"))
      .map(([k, v]) => `<div class="line__meta">${esc(k)}: ${String(v).includes("/uploads/") ? "photo attached" : esc(v)}</div>`).join("");
  }

  function renderCart(cart) {
    document.dispatchEvent(new CustomEvent("vb:cart", { detail: cart }));
    $$("[data-cart-count]").forEach(el => { el.textContent = cart.item_count; el.classList.toggle("has", cart.item_count > 0); });
    const n = $("[data-cart-n]"); if (!n) return;
    n.textContent = cart.item_count ? `(${cart.item_count})` : "";

    const msg = $("[data-ship-msg]"), bar = $("[data-ship-bar]");
    if (msg && T.settings.freeShipAt > 0) {
      const left = Math.max(0, T.settings.freeShipAt - cart.total_price);
      msg.innerHTML = left > 0 ? `You're <b>${money(left)}</b> away from <b>free shipping</b>` : `You've unlocked <b>free shipping</b> ✓`;
      bar.style.width = Math.min(100, cart.total_price / T.settings.freeShipAt * 100) + "%";
    }

    const lines = $("[data-lines]"), foot = $("[data-foot]");
    if (!cart.item_count) {
      lines.innerHTML = `<div class="empty"><p>Your cart is empty.</p><a class="btn btn--primary" href="/collections/all">Start shopping</a></div>`;
      foot.hidden = true; return;
    }
    foot.hidden = false;

    lines.innerHTML = cart.items.map(i => {
      const discounts = (i.line_level_discount_allocations || []).map(d =>
        `<div class="line__meta" style="color:var(--good);font-weight:700">${esc(d.discount_application.title)} (−${money(d.amount)})</div>`).join("");
      return `<div class="line">
        <a class="line__img" href="${i.url}">${i.image ? `<img src="${i.image}${i.image.includes("?") ? "&" : "?"}width=200" alt="" loading="lazy">` : ""}</a>
        <div>
          <div class="line__title">${esc(i.product_title)}</div>
          ${i.product_has_only_default_variant ? "" : `<div class="line__meta">${esc(i.variant_title || "")}</div>`}
          ${propsHTML(i.properties)}${discounts}
          <div class="line__qty"><button data-q="-1" data-key="${i.key}" aria-label="Decrease">−</button><span>${i.quantity}</span><button data-q="1" data-key="${i.key}" aria-label="Increase">+</button></div>
        </div>
        <div><div class="line__price">${money(i.final_line_price)}${i.original_line_price > i.final_line_price ? `<s>${money(i.original_line_price)}</s>` : ""}</div>
          <button class="line__rm" data-q="rm" data-key="${i.key}">Remove</button></div>
      </div>`;
    }).join("") + upsellHTML(cart);

    const cartDiscounts = (cart.cart_level_discount_applications || []).map(d =>
      `<div class="saved"><span>${esc(d.title)}</span><span>−${money(d.total_allocated_amount)}</span></div>`).join("");
    const saved = cart.original_total_price - cart.total_price;
    $("[data-totals]").innerHTML = `
      ${cartDiscounts}
      ${saved > 0 && !cartDiscounts ? `<div class="saved"><span>You're saving</span><span>${money(saved)}</span></div>` : ""}
      <div class="grand"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
      <div class="muted" style="font-size:12px">Shipping and taxes calculated at checkout.</div>`;
  }

  function upsellHTML(cart) {
    const inCart = new Set(cart.items.map(i => i.product_id));
    const offers = upsells.filter(u => !inCart.has(u.id)).slice(0, 2);
    if (!offers.length) return "";
    return `<div class="upsell__label">Players also add</div>` + offers.map(u => `
      <div class="upsell"><div class="upsell__img">${u.image ? `<img src="${u.image}" alt="" loading="lazy">` : ""}</div>
        <div><b>${esc(u.title)}</b><span>${money(u.price)}</span></div>
        ${u.quickAdd ? `<button data-upsell="${u.variant}">+ Add</button>` : `<a class="upsell__view" href="${u.url}">View</a>`}</div>`).join("");
  }

  async function changeLine(key, quantity) {
    const r = await fetch(T.routes.cartChange, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity }) });
    const cart = await r.json();
    if (!r.ok) { toast(cart.description || "Couldn't update the cart"); return; }
    renderCart(cart);
  }

  async function addToCart(body) {
    const r = await fetch(T.routes.cartAdd, { method: "POST", headers: { Accept: "application/json" }, body });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || "Couldn't add to cart");
    renderCart(await getCart());
    $$("[data-cart-count]").forEach(el => el.animate?.([{ transform: "scale(1.5)" }, { transform: "scale(1)" }], { duration: 350 }));
    return data;
  }

  function initDrawer() {
    if (!drawer()) return;
    $$("[data-open-cart]").forEach(a => a.addEventListener("click", e => { e.preventDefault(); openDrawer(); }));
    $$("[data-close]").forEach(b => b.addEventListener("click", closeDrawer));
    document.addEventListener("keydown", e => { if (e.key === "Escape") closeDrawer(); });
    $("[data-lines]").addEventListener("click", async e => {
      const up = e.target.closest("[data-upsell]");
      if (up) {
        up.disabled = true;
        try { const fd = new FormData(); fd.append("id", up.dataset.upsell); fd.append("quantity", 1); await addToCart(fd); toast("Added ✓"); }
        catch (err) { toast(err.message); up.disabled = false; }
        return;
      }
      const b = e.target.closest("[data-q]"); if (!b) return;
      const line = b.closest(".line"); line?.classList.add("is-busy");
      const current = parseInt(line?.querySelector(".line__qty span")?.textContent || "0", 10);
      await changeLine(b.dataset.key, b.dataset.q === "rm" ? 0 : Math.max(0, current + Number(b.dataset.q)));
    });
    getCart().then(renderCart).catch(() => {});
  }

  /* ==========================================================
     SLIDERS
     ========================================================== */
  function initRail(box) {
    const rail = $("[data-rail]", box); if (!rail || rail._init) return; rail._init = true;
    const prev = $("[data-prev]", box), next = $("[data-next]", box), bar = $("[data-progress] i", box);
    const step = () => rail.clientWidth * .85;
    prev?.addEventListener("click", () => rail.scrollBy({ left: -step(), behavior: "smooth" }));
    next?.addEventListener("click", () => rail.scrollBy({ left: step(), behavior: "smooth" }));
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const pct = max > 0 ? rail.scrollLeft / max : 1;
      if (bar) { const w = Math.max(18, rail.clientWidth / rail.scrollWidth * 100); bar.style.width = w + "%"; bar.style.marginLeft = pct * (100 - w) + "%"; }
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > max - 4;
    };
    rail.addEventListener("scroll", () => requestAnimationFrame(sync), { passive: true });
    addEventListener("resize", sync); sync();
  }

  /* KAIZEN-style rail: progress line + round arrows that move two cards at a time */
  function initVbRail(box) {
    const rail = $("[data-vb-rail]", box); if (!rail || rail._init) return; rail._init = true;
    const bar = $("[data-vb-progress]", box);
    const update = () => {
      if (!bar) return;
      const max = rail.scrollWidth - rail.clientWidth, view = rail.clientWidth / rail.scrollWidth;
      bar.style.width = Math.max(view, max > 0 ? view + (1 - view) * (rail.scrollLeft / max) : 1) * 100 + "%";
    };
    rail.addEventListener("scroll", () => requestAnimationFrame(update), { passive: true });
    addEventListener("resize", update); update();
    $$("[data-vb-scroll]", box).forEach(b => b.addEventListener("click", () => {
      const card = rail.firstElementChild;
      rail.scrollBy({ left: Number(b.dataset.vbScroll) * ((card?.offsetWidth || 280) + 16) * 2, behavior: "smooth" });
    }));
  }

  /* Quick add from product cards */
  function initQuickAdd() {
    const closeAll = except => $$("[data-vb-picker].is-open").forEach(p => {
      if (p === except) return;
      p.classList.remove("is-open");
      p.parentElement.querySelector("[data-vb-picker-toggle]")?.setAttribute("aria-expanded", "false");
    });
    document.addEventListener("click", async e => {
      const toggle = e.target.closest("[data-vb-picker-toggle]");
      if (toggle) {
        const picker = toggle.parentElement.querySelector("[data-vb-picker]");
        const open = !picker.classList.contains("is-open");
        closeAll(picker); picker.classList.toggle("is-open", open); toggle.setAttribute("aria-expanded", open);
        return;
      }
      const add = e.target.closest("[data-vb-add]");
      if (!add) { if (!e.target.closest("[data-vb-picker]")) closeAll(); return; }
      e.preventDefault();
      if (add.disabled || add.classList.contains("is-loading")) return;
      add.classList.add("is-loading");
      try {
        const fd = new FormData(); fd.append("id", add.dataset.vbAdd); fd.append("quantity", 1);
        await addToCart(fd);
        add.classList.remove("is-loading"); add.classList.add("is-added");
        setTimeout(() => { add.classList.remove("is-added"); closeAll(); }, 1400);
        openDrawer();
      } catch (err) { add.classList.remove("is-loading"); toast(err.message); }
    });
    document.addEventListener("keydown", e => { if (e.key === "Escape") closeAll(); });
  }

  async function initComplete() {
    const el = $("[data-complete]"); if (!el) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const fresh = new DOMParser().parseFromString(html, "text/html");
      const list = fresh.querySelector("[data-complete-list]");
      if (list && list.children.length) { $("[data-complete-list]", el).replaceWith(list); return; }
    } catch {}
    if ($("[data-complete-empty]", el)) el.hidden = true;
  }

  async function initRecommendations() {
    const el = $("[data-recommendations]"); if (!el) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-recommendations]");
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initVbRail(el); el.querySelectorAll(".reveal").forEach(r => r.classList.add("is-visible")); }
    } catch {}
  }

  /* ==========================================================
     DELIVERY ESTIMATE (real clock, business days)
     ========================================================== */
  const isWeekend = d => d.getDay() === 0 || d.getDay() === 6;
  const nextBiz = d => { const n = new Date(d); do n.setDate(n.getDate() + 1); while (isWeekend(n)); return n; };
  const addBiz = (d, k) => { let n = new Date(d); for (let i = 0; i < k; i++) n = nextBiz(n); return n; };
  const fmt = d => d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
  function initDelivery() {
    const box = $("[data-countdown]"); if (!box) return;
    const made = $("[data-product]")?.dataset.madeToOrder === "true";
    const tick = () => {
      const now = new Date(), cutoff = new Date(now); cutoff.setHours(T.settings.cutoffHour, 0, 0, 0);
      const today = !made && !isWeekend(now) && now < cutoff;
      const ship = made ? addBiz(now, T.settings.madeToOrderDays) : today ? now : nextBiz(now);
      if (today) { const ms = cutoff - now, h = Math.floor(ms / 36e5), m = Math.floor(ms % 36e5 / 6e4); box.innerHTML = `Order within <span class="countdown">${h ? h + "h " : ""}${m}m</span> to ship <b>today</b>`; }
      else box.innerHTML = made ? `Made to order. Ships by <b>${fmt(ship)}</b>` : `Order now, ships <b>${fmt(ship)}</b>`;
      { const DAY = 864e5, a = new Date(now.getTime() + 8 * DAY), b = new Date(now.getTime() + 12 * DAY), mo = d => d.toLocaleDateString(undefined, { month: "short" });
        $("[data-arrive]").textContent = mo(a) === mo(b) ? `${mo(a)} ${a.getDate()} \u2013 ${b.getDate()}` : `${mo(a)} ${a.getDate()} \u2013 ${mo(b)} ${b.getDate()}`; }
    };
    tick(); setInterval(tick, 30000);
  }

  /* ==========================================================
     PRODUCT PAGE
     ========================================================== */
  function initProduct() {
    const root = $("[data-product]"); if (!root) return;
    let P; try { P = JSON.parse($("[data-product-json]").textContent); } catch { return; }
    const form = $("[data-product-form]"), idInput = $("[data-variant-id]", form);
    let variant = P.variants.find(v => String(v.id) === idInput.value) || P.variants[0];

    const qty = () => {
      const r = $('input[name="quantity"]:checked', form); if (r) return +r.value;
      return Math.max(1, parseInt($("[data-qty]", form)?.value || "1", 10));
    };
    const tierOff = q => (P.tiers.filter(t => q >= t.qty).pop() || { off: 0 }).off / 100;

    function update() {
      const q = qty(), total = Math.round(variant.price * q * (1 - tierOff(q)));
      $("[data-price]").textContent = money(variant.price);
      const cmp = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
      $("[data-compare]").textContent = cmp ? money(cmp) : "";
      const save = $("[data-save]"); save.hidden = !cmp; if (cmp) save.textContent = `Save ${money(cmp - variant.price)}`;
      const split = $("[data-split-wrap]");
      if (split) { split.hidden = !(T.settings.showPayIn4 && total >= T.settings.payIn4Min); $("[data-split]").textContent = money(Math.round(total / 4)); }
      const unit = $("[data-unit-price]"); if (unit) unit.textContent = money(variant.price);
      $$("[data-atc-label]").forEach(el => el.textContent = variant.available ? (el.dataset.idleLabel || `Add to cart · ${money(total)}`) : "Sold out");
      $$("[data-atc], [data-sticky-btn], .vb-final button[form]").forEach(b => b.disabled = !variant.available);
      const low = $("[data-low-stock]"), inv = P.inventory[variant.id];
      low.hidden = !(variant.available && inv !== null && inv !== undefined && inv > 0 && inv <= P.lowStock);
      if (!low.hidden) low.textContent = `Only ${inv} left`;
      const meta = $("[data-sticky-meta]"); if (meta && variant.title !== "Default Title") meta.textContent = variant.title;
      shipProgress(total);
    }

    // "Add this and you're $X from free shipping", using the real cart total
    let cartTotal = 0;
    function shipProgress(lineTotal) {
      const box = $("[data-pdp-ship]"); if (!box || !T.settings.freeShipAt) return;
      const after = cartTotal + lineTotal, goal = T.settings.freeShipAt;
      box.hidden = false;
      box.classList.toggle("is-done", after >= goal);
      $("[data-pdp-ship-msg]").innerHTML = after >= goal
        ? (cartTotal >= goal ? "Your order ships <b>free</b>" : "Add this and your order ships <b>free</b>")
        : `Add this and you're <b>${money(goal - after)}</b> from free shipping`;
      $("[data-pdp-ship-bar]").style.width = Math.min(100, after / goal * 100) + "%";
    }
    getCart().then(c => { cartTotal = c.total_price; update(); }).catch(() => {});
    document.addEventListener("vb:cart", e => { cartTotal = e.detail.total_price; update(); });

    // Option pickers → matching variant
    $$("[data-option]").forEach(fs => fs.addEventListener("change", () => {
      const chosen = $$("[data-option]").map(f => $("input:checked", f)?.value);
      $$("[data-option]").forEach((f, i) => { const s = $("[data-opt-selected]", f); if (s) s.textContent = chosen[i]; });
      variant = P.variants.find(v => v.options.every((o, i) => o === chosen[i])) || variant;
      const exact = P.variants.some(v => v.options.every((o, i) => o === chosen[i]));
      idInput.value = variant.id;
      if (!exact) { $$("[data-atc-label]").forEach(el => el.textContent = "Unavailable"); $$("[data-atc], [data-sticky-btn]").forEach(b => b.disabled = true); return; }
      history.replaceState(null, "", `?variant=${variant.id}`);
      update();
      if (variant.featured_media) goToSlide($(`[data-media-id="${variant.featured_media.id}"]`));
    }));
    form.addEventListener("change", e => { if (e.target.name === "quantity") update(); });
    form.addEventListener("click", e => {
      const s = e.target.closest("[data-step]"); if (!s) return;
      const i = $("[data-qty]", form); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + +s.dataset.step); update();
    });
    $("[data-qty]", form)?.addEventListener("input", update);

    // Couple card live preview
    const namesIn = $('[data-cc-input="names"]'), dateIn = $('[data-cc-input="date"]');
    const setText = (sel, v, fallback) => $$(sel).forEach(el => el.textContent = v.trim() || fallback);
    $$("[data-cc-input]").forEach(inp => inp.addEventListener("input", () => {
      inp.classList.remove("is-missing");
      const c = $(`[data-count-for="${inp.id}"]`); if (c) c.textContent = `${inp.value.length}/${inp.maxLength}`;
      if (inp === namesIn) setText("[data-product] [data-cc-names]", inp.value, "Alex & Jordan");
      if (inp === dateIn) setText("[data-product] [data-cc-date]", inp.value, "day one");
    }));
    const photo = $("[data-cc-photo]");
    photo?.addEventListener("change", () => {
      const f = photo.files[0]; if (!f) return;
      $("[data-upload-name]").textContent = `✓ ${f.name}`;
      const r = new FileReader();
      r.onload = () => { $$("[data-product] [data-cc-art]").forEach(a => a.innerHTML = `<img src="${r.result}" alt="">`); goToSlide($("[data-slide]")); };
      r.readAsDataURL(f);
    });

    // Generic personalization box: live character count, photo name, required check
    const pz = $("[data-pz]", form);
    pz?.addEventListener("input", () => {
      pz.classList.remove("is-missing");
      const c = $('[data-count-for="pz-text"]'); if (c) c.textContent = `${pz.value.length}/${pz.maxLength}`;
    });
    $("[data-pz-photo]", form)?.addEventListener("change", e => {
      const f = e.target.files[0]; const n = $("[data-pz-photo-name]"); if (f && n) n.textContent = `✓ ${f.name}`;
    });

    // Submit → AJAX add (FormData keeps line item properties and the photo upload)
    form.addEventListener("submit", async e => {
      e.preventDefault();
      if (pz && pz.hasAttribute("data-pz-required") && !pz.value.trim()) {
        pz.classList.add("is-missing"); pz.scrollIntoView({ block: "center", behavior: "smooth" });
        pz.focus({ preventScroll: true }); toast("Add your personalization first"); return;
      }
      if (namesIn && !namesIn.value.trim()) {
        namesIn.classList.add("is-missing"); namesIn.scrollIntoView({ block: "center", behavior: "smooth" });
        namesIn.focus({ preventScroll: true }); toast("Add your names to preview and order"); return;
      }
      if (form.dataset.submitting === "true") return;
      const err = $("[data-form-error]"); err.hidden = true;
      const btns = $$("[data-atc], [data-sticky-btn]"); btns.forEach(b => b.classList.add("is-busy"));
      const cleanLabels = $$('[data-idle-label]', form);
      form.dataset.submitting = "true";
      btns.forEach(b => b.setAttribute("aria-busy", "true"));
      cleanLabels.forEach(el => el.textContent = el.dataset.addingLabel);
      let added = false;
      try {
        await addToCart(new FormData(form));
        added = true;
        cleanLabels.forEach(el => el.textContent = el.dataset.addedLabel);
        openDrawer();
      }
      catch (ex) { err.textContent = ex.message; err.hidden = false; }
      finally {
        form.dataset.submitting = "false";
        btns.forEach(b => { b.classList.remove("is-busy"); b.removeAttribute("aria-busy"); });
        if (!added) cleanLabels.forEach(el => el.textContent = el.dataset.idleLabel);
        else setTimeout(update, 1800);
      }
    });

    // Gallery
    const track = $("[data-track]"), slides = $$("[data-slide]", track);
    const dots = $("[data-dots]");
    if (dots && slides.length > 1) dots.innerHTML = slides.map((_, i) => `<button type="button" aria-label="Go to image ${i + 1}"></button>`).join("");
    const padL = () => parseFloat(getComputedStyle(track).paddingLeft) || 0;
    const curIdx = () => { const x = track.scrollLeft + padL(); let bi = 0, bd = 1e9; slides.forEach((s, i) => { const d = Math.abs(s.offsetLeft - x); if (d < bd) { bd = d; bi = i; } }); return bi; };
    function goToSlide(slide) { if (slide) track.scrollTo({ left: slide.offsetLeft - padL(), behavior: "smooth" }); }
    const syncDots = () => {
      const i = curIdx();
      slides.forEach((s, k) => s.classList.toggle("is-active", k === i));
      $$("button", dots).forEach((d, k) => d.classList.toggle("on", k === i));
      $$("[data-thumbs] button").forEach((d, k) => {
        d.classList.toggle("on", k === i);
        // keep the active thumbnail centred in the strip (horizontal only, never moves the page)
        if (k === i && d.parentElement.scrollWidth > d.parentElement.clientWidth) { const st = d.parentElement; st.scrollTo({ left: d.offsetLeft - (st.clientWidth - d.offsetWidth) / 2, behavior: "smooth" }); }
      });
    };
    dots?.addEventListener("click", e => { const i = $$("button", dots).indexOf(e.target.closest("button")); if (i >= 0) goToSlide(slides[i]); });
    $("[data-thumbs]")?.addEventListener("click", e => { const b = e.target.closest("[data-go]"); if (b) goToSlide(slides[+b.dataset.go]); });
    track.addEventListener("scroll", () => requestAnimationFrame(syncDots), { passive: true });
    syncDots();

    // Two-sided cards: tap the card or the button to flip it
    slides.filter(sl => sl.classList.contains("has-flip")).forEach(sl => {
      const btn = $("[data-flip]", sl), lab = $("[data-flip-label]", sl);
      const flip = () => { const on = sl.classList.toggle("is-flipped"); btn.setAttribute("aria-pressed", on); lab.textContent = on ? "Flip back" : "Tap to flip"; };
      btn.addEventListener("click", e => { e.stopPropagation(); flip(); });
      $(".slide__cardwrap", sl).addEventListener("click", flip);
    });

    // Counter + arrows
    const cur = $("[data-g-cur]");
    const idx = curIdx;
    const syncCount = () => { if (cur) cur.textContent = String(idx() + 1).padStart(2, "0"); };
    track.addEventListener("scroll", () => requestAnimationFrame(syncCount), { passive: true });
    $$("[data-g-step]").forEach(b => b.addEventListener("click", () => {
      const n = (idx() + Number(b.dataset.gStep) + slides.length) % slides.length; goToSlide(slides[n]);
    }));

    // Full-screen zoom (images only)
    const zoomSlides = slides.filter(sl => sl.dataset.zoomSrc);
    if (zoomSlides.length) {
      const dlg = document.createElement("dialog");
      dlg.className = "vb-zoom";
      dlg.innerHTML = `<button type="button" class="vb-zoom__close" aria-label="Close zoom"><span aria-hidden="true">✕</span> Close</button>
        <div class="vb-zoom__track">${zoomSlides.map(sl => `<div class="vb-zoom__slide"><img src="${sl.dataset.zoomSrc}" alt="" loading="lazy" decoding="async"></div>`).join("")}</div>
        <p class="vb-zoom__hint" data-zoom-hint>Swipe · tap to zoom · drag to look around</p>`;
      document.body.appendChild(dlg);
      const zt = $(".vb-zoom__track", dlg);
      const open = sl => {
        const i = Math.max(0, zoomSlides.indexOf(sl));
        [i - 1, i, i + 1, i + 2].forEach(k => { const im = zt.children[k]?.querySelector("img"); if (im) im.loading = "eager"; });
        // Then quietly load the rest one by one, so later swipes don't wait on the network
        const rest = [...zt.querySelectorAll("img")].filter(im => im.loading !== "eager");
        const next = () => { const im = rest.shift(); if (!im || !dlg.open) return; im.loading = "eager"; if (im.complete) next(); else { im.addEventListener("load", next, { once: true }); im.addEventListener("error", next, { once: true }); } };
        setTimeout(next, 600);
        dlg.showModal(); document.body.style.overflow = "hidden";
        requestAnimationFrame(() => { zt.scrollLeft = i * zt.clientWidth; });
      };
      // Preload the photos either side of the one in view so swiping never lands on a loading spinner
      const warm = () => { const i = Math.round(zt.scrollLeft / zt.clientWidth); [i - 1, i + 1, i + 2].forEach(k => { const im = zt.children[k]?.querySelector("img"); if (im && im.loading !== "eager") im.loading = "eager"; }); };
      zt.addEventListener("scroll", () => requestAnimationFrame(warm), { passive: true });
      const close = () => { dlg.close(); };
      // Tap zooms in where you tapped; while zoomed, drag to look around the card (Hotjar showed people
      // re-tapping 10-15x to read different parts). Swiping between photos is paused until you zoom out.
      const setZoom = (sl, on, x, y) => {
        const img = sl.querySelector("img");
        sl.classList.toggle("is-zoomed", on);
        zt.classList.toggle("is-locked", on);
        if (on) { const r = img.getBoundingClientRect(); img._ox = (x - r.left) / r.width * 100; img._oy = (y - r.top) / r.height * 100; img.style.transformOrigin = `${img._ox}% ${img._oy}%`; }
      };
      dlg.addEventListener("close", () => { document.body.style.overflow = ""; zt.classList.remove("is-locked"); $$(".is-zoomed", dlg).forEach(z => z.classList.remove("is-zoomed")); });
      $(".vb-zoom__close", dlg).addEventListener("click", close);
      let drag = null, dragged = false;
      dlg.addEventListener("pointerdown", e => {
        const sl = e.target.closest(".vb-zoom__slide.is-zoomed"); dragged = false;
        if (!sl || e.target.tagName !== "IMG") return;
        const img = e.target, r = img.getBoundingClientRect();
        drag = { img, x: e.clientX, y: e.clientY, ox: img._ox ?? 50, oy: img._oy ?? 50, w: r.width, h: r.height };
        img.setPointerCapture?.(e.pointerId); img.style.transition = "none";
      });
      dlg.addEventListener("pointermove", e => {
        if (!drag) return;
        const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) + Math.abs(dy) > 6) dragged = true;
        // Drag the card under your finger: moving left reveals the right side
        const k = 100 / 1.4;
        drag.img._ox = Math.min(100, Math.max(0, drag.ox - dx / drag.w * k));
        drag.img._oy = Math.min(100, Math.max(0, drag.oy - dy / drag.h * k));
        drag.img.style.transformOrigin = `${drag.img._ox}% ${drag.img._oy}%`;
      });
      const endDrag = () => { if (drag) { drag.img.style.transition = ""; drag = null; } };
      dlg.addEventListener("pointerup", endDrag); dlg.addEventListener("pointercancel", endDrag);
      dlg.addEventListener("click", e => {
        const sl = e.target.closest(".vb-zoom__slide");
        if (!sl) return close();
        if (e.target.tagName !== "IMG") return;
        if (dragged) { dragged = false; return; }
        setZoom(sl, !sl.classList.contains("is-zoomed"), e.clientX, e.clientY);
      });
      zoomSlides.forEach(sl => { sl.style.cursor = "zoom-in"; sl.addEventListener("click", () => open(sl)); });
      $("[data-zoom-open]")?.addEventListener("click", () => open(slides[idx()]?.dataset.zoomSrc ? slides[idx()] : zoomSlides[0]));
    }

    // Sticky buy bar whenever the main button is off screen
    const sticky = $("[data-sticky]"), mainBtn = $("[data-atc]", form), footer = $(".footer");
    let ticking = false;
    const stick = () => {
      ticking = false;
      const r = mainBtn.getBoundingClientRect();
      // Only after the main button has scrolled up out of view, never alongside it
      const passed = r.bottom < 70;
      const on = passed && (!footer || footer.getBoundingClientRect().top > innerHeight);
      sticky.classList.toggle("show", on); sticky.setAttribute("aria-hidden", !on);
      $("[data-sticky-btn]").tabIndex = on ? 0 : -1;
    };
    addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(stick); } }, { passive: true });
    stick();
    update();
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    $("[data-sort]")?.addEventListener("change", e => {
      const u = new URL(location.href); u.searchParams.set("sort_by", e.target.value); u.searchParams.delete("page"); location.href = u;
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initMenu(); initDrawer(); initProduct(); initDelivery(); initSort();
    $$("[data-rail-box]").forEach(initRail);
    $$("[data-vb-rail-box]").forEach(initVbRail);
    initQuickAdd();
    window.VBCart = { add: addToCart, open: openDrawer, refresh: () => getCart().then(renderCart) };
    initRecommendations();
    initComplete();
    $$("[data-vb-top]").forEach(a => a.addEventListener("click", e => { e.preventDefault(); scrollTo({ top: 0, behavior: "smooth" }); }));
    const sg = $("[data-sizeguide]");
    if (sg) {
      $$("[data-sizeguide-open]").forEach(b => b.addEventListener("click", () => sg.showModal()));
      $("[data-sizeguide-close]", sg).addEventListener("click", () => sg.close());
      sg.addEventListener("click", e => { if (e.target === sg) sg.close(); });
    }
  });
})();
/* NO-SAVE: block the save-image menu and dragging on gallery + zoom images */
(() => { const hit = e => e.target && e.target.closest && e.target.closest(".gallery, .vb-zoom"); ["contextmenu", "dragstart"].forEach(t => document.addEventListener(t, e => { if (hit(e) && (t === "dragstart" || e.target.tagName === "IMG" || e.target.closest(".slide, .vb-zoom__slide"))) e.preventDefault(); })); document.addEventListener("selectstart", e => { if (hit(e)) e.preventDefault(); }); })();
